// extracted by mini-css-extract-plugin
export default {"title":"TableTitle_title__9LhIw"};